<template>
<div>
  <img src="../../assets/loaderV5.gif" alt="Loader spinner" :style="{'height': height + 'px', 'width': width + 'px'}">
</div>
</template>

<script>

export default {
  name: 'LoaderSpinner',
  props: {
    height: {
      type: Number,
      default: 185
    },
    width: {
      type: Number,
      default: 185
    }
  }
}
</script>
